import { Component, OnInit } from '@angular/core';
import { User } from '../../../model/user.model';
import { NgForm } from '@angular/forms';
import { UserService } from '../../../services/user/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-adduser',
  templateUrl: './adduser.component.html',
  styleUrls: ['./adduser.component.css']
})
export class AdduserComponent implements OnInit {

  data: any;
  RoleDataAny: any;
  user : User;
  isLoading : boolean = false;
  isRegisterSuccess : boolean = false;
  isRegisterFailure : boolean = false;

  selecteduserstatus: string;

  userstatusoptions = [
    { name: "Inactive", value: "inactive" },
    { name: "Active", value: "active" }
  ]

  constructor(private userService : UserService, private router: Router) { }

  ngOnInit() {
    this.resetForm();
    this.getRoleValue();

  }

  getRoleValue() {
    this.userService.getRoleValue().subscribe(
      (data) => {
        this.RoleDataAny = data;
        this.data = this.RoleDataAny;
        console.log("user data" + this.data);
      }
    )
  }

  resetForm(form? : NgForm)
  {
    if(form != null)
    form.reset();
    this.user = new User;
    // this.user={
    //   Email : '',
    //   Password : '',
    //   ConfirmPassword : '',
    //   PhoneNumber : '',
    //   Address : '',
    //   userType : '',
    //   FullName : '',
    //   VendorCode : '',
    //   type : '',
    //   IsActive : '',
    //   CreatedBy : '',
    //   CreatedOn : '',
    //   UpdatedBy : '',
    //   UpdatedOn : '',
    //   RegisterCode : '',
    //   Error : '',
    //   changesAllow : false
    // }
  }

  OnSubmit(form : NgForm)
  {
    debugger;
    this.isLoading = true;
    this.isRegisterFailure = false;
    this.isRegisterSuccess = false;

    this.userService.getRoleValue().subscribe(
      (data) => {
        this.RoleDataAny = data;
        this.data = this.RoleDataAny;
      }
    )

    for(var i=0; i<this.data.length;i++)
    {
      if(this.data[i].id == form.value.roleType)
      {
        form.value.roleName = this.data[i].name;
        break;
      }
    }
    form.value.userType = "3";
    if(form.value.userType)
    {
      if(form.value.userType == "1")
      {
        form.value.registerCode = "royaladmin";
      }
      else if(form.value.userType == "3")
      {
        // form.value.registerCode = "dpvppurchase";
        form.value.registerCode = "dpvpgeneral";
      }
      else if(form.value.userType == "4")
      {
        form.value.registerCode = "dpvpfinance";
      }
      else if(form.value.userType == "5")
      {
        form.value.registerCode = "dpvpsiteinc";
      }
      else if(form.value.userType == "6")
      {
        form.value.registerCode = "dpvptransport";
      }
      else if(form.value.userType == "2")
      {
        form.value.registerCode = "vendor";
      }
      else {}
    }

    console.log(form.value);
    this.userService.registerUser(form.value)
      .subscribe((data : any) => {
          if(data == true)
          {
            this.resetForm(form);
            this.isLoading = false;
            this.isRegisterSuccess = true;
          }
          else
          {
            this.isLoading = false;
            this.isRegisterFailure = true;
          }
      });
  }


}
